"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:jsx-no-lambda
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
require("./Section.scss");
exports.Section = function (props) {
    var content;
    if (props.expanded || !props.expandable) {
        var contentClassNames = props.contentClassNames ? props.contentClassNames.concat(' row') : 'row';
        // tslint:disable-next-line:jsx-wrap-multiline
        content = React.createElement("div", { className: contentClassNames },
            React.createElement("div", { className: 'col-lg-12' }, props.children));
    }
    var disabled = props.disabled ? true : false;
    var sectionClasses = classNames({
        section: true,
        disabled: disabled,
    });
    var expandIcon;
    if (props.expandable) {
        var iconStyle = props.expanded ? 'down' : 'right';
        expandIcon = (React.createElement("div", { className: 'col-lg-1 text-right' },
            React.createElement("p", { className: 'expandedContentIcon clickable', key: props.title + "-expand-icon", onClick: function () { return props.toggleExpand(); } },
                React.createElement(Icon_1.Icon, { icon: iconStyle }))));
    }
    var sectionTitleClasses = classNames({
        sectionTitle: true,
        disabled: disabled,
        invalid: !disabled && props.validationState === 'invalid',
        valid: !disabled && props.validationState === 'valid'
    });
    return (React.createElement("div", { className: sectionClasses },
        React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-lg-11' },
                React.createElement("p", { className: sectionTitleClasses }, props.title)),
            expandIcon),
        content));
};
//# sourceMappingURL=Section.js.map